import { VOID_CAVE_DEPTHS_EXIT_RECTS } from "./voidCaveDepthsMapConfig";
import {
  CRYSTAL_BASIN_MAP_CONFIG,
  EAST_PASSAGE_MAP_CONFIG,
  ECHO_VAULT_MAP_CONFIG,
  SHATTERED_REACH_MAP_CONFIG,
} from "./eastPassageMapConfigs";

const TILE_SIZE = 32;

export const EAST_PASSAGE_SCENE_KEY = "EastPassageScene";
export const CRYSTAL_BASIN_SCENE_KEY = "CrystalBasinScene";
export const ECHO_VAULT_SCENE_KEY = "EchoVaultScene";
export const SHATTERED_REACH_SCENE_KEY = "ShatteredReachScene";

const spawnBelowDoor = (rect) =>
  Object.freeze({
    x: rect.x + rect.width / 2,
    y: rect.y + rect.height + TILE_SIZE / 2,
  });

export const EAST_PASSAGE_RETURN_SPAWNS = Object.freeze({
  fromWestDoor: spawnBelowDoor(EAST_PASSAGE_MAP_CONFIG.exitRects.westDoor),
  fromNorthDoor: spawnBelowDoor(EAST_PASSAGE_MAP_CONFIG.exitRects.northDoor),
  fromEastDoor: spawnBelowDoor(EAST_PASSAGE_MAP_CONFIG.exitRects.eastDoor),
});

export const DEEP_HOLLOWS_EAST_DOOR_RETURN_SPAWN = spawnBelowDoor(
  VOID_CAVE_DEPTHS_EXIT_RECTS.eastExit,
);

const HUB_EXIT_ROUTES = Object.freeze({
  westDoor: Object.freeze({
    sceneKey: CRYSTAL_BASIN_SCENE_KEY,
    spawn: CRYSTAL_BASIN_MAP_CONFIG.entrySpawn,
    doorLabel: "Enter Passage",
  }),
  northDoor: Object.freeze({
    sceneKey: ECHO_VAULT_SCENE_KEY,
    spawn: ECHO_VAULT_MAP_CONFIG.entrySpawn,
    doorLabel: "Enter Passage",
  }),
  eastDoor: Object.freeze({
    sceneKey: SHATTERED_REACH_SCENE_KEY,
    spawn: SHATTERED_REACH_MAP_CONFIG.entrySpawn,
    doorLabel: "Enter Passage",
  }),
});

const SHATTERED_REACH_EXIT_ROUTES = Object.freeze({
  northExit: Object.freeze({
    sceneKey: null,
    spawn: null,
    doorLabel: "Continue Passage",
    sealedMessage: "The passage continues into darkness... it is sealed for now.",
  }),
});

export const EAST_PASSAGE_SCENE_ROUTING = Object.freeze({
  [EAST_PASSAGE_SCENE_KEY]: Object.freeze({
    mapConfig: EAST_PASSAGE_MAP_CONFIG,
    storyMapId: "eastPassage",
    storySpawnId: "east-passage-entry",
    entranceRoute: Object.freeze({
      sceneKey: "VoidCaveDepthsScene",
      spawn: DEEP_HOLLOWS_EAST_DOOR_RETURN_SPAWN,
      doorLabel: "Return To The Deep Hollows",
    }),
    entranceLabel: "Deep Hollows",
    exitRoutes: HUB_EXIT_ROUTES,
  }),
  [CRYSTAL_BASIN_SCENE_KEY]: Object.freeze({
    mapConfig: CRYSTAL_BASIN_MAP_CONFIG,
    storyMapId: "crystalBasin",
    storySpawnId: "crystal-basin-entry",
    entranceRoute: Object.freeze({
      sceneKey: EAST_PASSAGE_SCENE_KEY,
      spawn: EAST_PASSAGE_RETURN_SPAWNS.fromWestDoor,
      doorLabel: "Return To East Passage",
    }),
    entranceLabel: "East Passage",
    exitRoutes: Object.freeze({}),
  }),
  [ECHO_VAULT_SCENE_KEY]: Object.freeze({
    mapConfig: ECHO_VAULT_MAP_CONFIG,
    storyMapId: "echoVault",
    storySpawnId: "echo-vault-entry",
    entranceRoute: Object.freeze({
      sceneKey: EAST_PASSAGE_SCENE_KEY,
      spawn: EAST_PASSAGE_RETURN_SPAWNS.fromNorthDoor,
      doorLabel: "Return To East Passage",
    }),
    entranceLabel: "East Passage",
    exitRoutes: Object.freeze({}),
  }),
  [SHATTERED_REACH_SCENE_KEY]: Object.freeze({
    mapConfig: SHATTERED_REACH_MAP_CONFIG,
    storyMapId: "shatteredReach",
    storySpawnId: "shattered-reach-entry",
    entranceRoute: Object.freeze({
      sceneKey: EAST_PASSAGE_SCENE_KEY,
      spawn: EAST_PASSAGE_RETURN_SPAWNS.fromEastDoor,
      doorLabel: "Return To East Passage",
    }),
    entranceLabel: "East Passage",
    exitRoutes: SHATTERED_REACH_EXIT_ROUTES,
  }),
});
